import { createTypes } from "@/store/utils";

export const CREATE_TICKET = createTypes("CREATE_TICKET");
export const UPLOAD_ATTACHMENTS = createTypes("UPLOAD_ATTACHMENTS");
export const DELETE_ATTACHMENT = createTypes("DELETE_ATTACHMENT");
export const UPDATE_REQUEST = createTypes("UPDATE_REQUEST");
export const CREATE_REQUEST = createTypes("CREATE_REQUEST");
